module.exports = __webpack_public_path__ + "img/avatar_real_6.119a2e04.jpg";